<template>
    <v-app>
        <!--<v-alert style="background-color:silver" v-if="isSuccess">ログイン成功</v-alert>
        <v-alert style="background-color:silver" v-if="isError">ログイン失敗...</v-alert>-->
        <!--(仮で仕上げたやつ)-->
        <v-row align="center"
               justify="center">
            <v-col cols="12">

                <v-card class="mx-auto"
                        color="blue lighten-5"
                        height="480"
                        max-width="430">
                    <v-toolbar color="#0075c2" class="white--text text-h5"  flat>運送業務システム</v-toolbar>
                    <v-card-text class="mt-13 text-center text-h6">

                        <!--<font size="6"><b>運送業務システム</b></font>-->
                        <font size="5"><b> ログイン画面</b></font>
                        <div align="center" class="my-0" style="color:grey">
                            <span>Ver - {{ version }}</span>
                        </div>
                        <v-col cols="12"
                               sm="100"
                               md="300">

                            <v-text-field label="ID"
                                          single-line
                                          class="mt-8"
                                          v-model="search_condition.login_id"
                                          solo></v-text-field>
                        </v-col>


                        <v-col cols="12"
                               class="mt-n6"
                               sm="100"
                               md="300">
                            <v-text-field type="password" label="Password" v-model="search_condition.password" single-line
                                          solo></v-text-field>
                        </v-col>

                        <!--
                テスト用
            <v-btn depressed
                   onclick="location.href='http://192.168.6.15:5000/top'"
                   elevation="4"
                   height="40" width="120">Login</v-btn>

            <v-btn depressed
                   v-on:click="addValue()"
                   elevation="4"
                   height="40" width="120">お試し</v-btn>
            -->
                    </v-card-text>
                    <div align="center">
                        <v-btn depressed
                               @click="doLogin"
                               elevation="4"
                               class="white--text"
                               color="#0075c2"
                               height="40" width="120">Login</v-btn>
                    </div>



                    <!--
        <p>
            {{ansId}}
            {{Id}}
        </p>-->



                </v-card>
                <!--<p>
                    {{ref_data}}
                </p>-->

            </v-col>

            

        </v-row>


        <div>
            <v-dialog v-model="dialog"
                      width="400px">
                <v-card width="400px"
                        class="mx-auto ">
                    <v-card-title>IDまたはパスワードが違います</v-card-title>
                </v-card>
            </v-dialog>
        </div>



    </v-app>
</template>
<script>
    //import axios from 'axios';

    export default {
        data: () => ({
            version: g_version,
            checkbox: true,
            ID: "",
            pass: "",
            ansId: "1234",
            anspass: "1111",
            dialog: false,
            users: [],
            info: "JILSA",
            test:"",
            //params: {
            //    name: '',
            //    pass: '',
            //},
            error: "",
            isSuccess: false,
            isError: false,

            search_condition: {
                login_id: '',
                password:'',
            },
            ref_data: [],
        }),




        methods: {
            addValue() {
                //if (this.Id == this.ansId) {
                if (this.Id == this.ansId && this.password == this.anspass) {
                    location.href = "http://192.168.6.15:5000/top"
                } else {
                    this.dialog = true
                    //this.Id = ""
                    //this.password = ""
                }

            },

            /*
            async onSearch() {
                try {

                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.search_condition));
                    let res = await this.axios_post('/LoginPC/Search', params);
                    if (res.data.status !== 'OK') {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                } catch (err) {
                    console.log(err);
                }
            },

        },*/

            /*
            mounted: function () {
                axios.get('http://192.168.6.15:5000/LoginInfo')
                    .then(response => this.users = response.data.movieList)
                    .catch(error => console.log(error))
            },*/



            /*
            new Vue({
                el: '#mvList',
                data: {
                    users: []
                },
                mounted: function () {
                    axios.get('https://localhost:7253/HelloWorld')
                        .then(response => this.users = response.data.movieList)
                        .catch(error => console.log(error))
                },

            })*/

            async doLogin() {

                try {

                    this.ref_data = [];
                    // 入力データをJSONで送信するために整形
                    var params = new URLSearchParams();
                    params.append("param", JSON.stringify(this.search_condition));

                    /*
                     * 非同期で任意のURLにリクエストを送るメソッド
                     * Axios.post(URL, POSTで送信するパラメータ)
                     * response → 帰ってくる値を格納しているデータ
                     * awaitは非同期で勝手に実行してくれる便利なやつ
                     * responseを使うときに、あればそのままなければ待ち続ける
                     */
                    let response = await this.axios_post("/LoginPC/CheckLogin", params);

                    /*
                     * ログイン結果の格納
                     */
                    //this.isSuccess = response.data.Status === "OK";
                    //this.dialog  = !this.isSuccess;
                    //if (this.isError) {
                    //    return;
                    //}
                    //if (this.isSuccess == true) {
                    //    window.location.href = "/top";
                    //} else {
                    //    this.dialog = !this.isSuccess;
                    //}
                    if (response.data.status != "OK") {
                        this.dialog = true;
                        //return;
                    } else {
                        this.ref_data = response.data.items;
                        //this.setCookie("Token", response.data.Token);
                        //this.setCookie("UserName", response.data.UserName);
                        
                        window.location.href = "/top";
                    }

                    
                    //this.ref_data = response.data.items;

                    /*
                     * 検索画面へ遷移
                     */

                    console.log(response.data);

                    //this.setCookie("Token", response.data.Token);
                    //this.setCookie("UserName", response.data.UserName);

                    //console.log(this.getCookie("Token"));
                   // window.location.href = "/top";
                }
                // エラーをキャッチしたとき
                catch (error) {
                //    this.error = error;
                //    this.isSuccess = false;
                //    this.isError = true;
                }
            }
        }
    }

</script>
